// extracted by mini-css-extract-plugin
export const required = "index-module--required--6kQqj";
export const elective = "index-module--elective--33H70";
export const subheading = "index-module--subheading--3owqk";
export const bgYellow = "index-module--bg-yellow--3tWS6";
export const headingLine = "index-module--heading-line--1VR_6";
export const gray = "index-module--gray--ad_8N";
export const requiredIcon = "index-module--required-icon--3eVHP";
export const inductionTip = "index-module--induction-tip--22gSP";
export const comment = "index-module--comment--YqIQo";
export const iconHelp = "index-module--icon-help--137Fy";
export const isNone = "index-module--is-none--3Qleq";